import { render, staticRenderFns } from "./CommodityAllocationListFunc.vue?vue&type=template&id=2dd5351f&scoped=true&"
import script from "./CommodityAllocationListFunc.vue?vue&type=script&lang=js&"
export * from "./CommodityAllocationListFunc.vue?vue&type=script&lang=js&"
import style0 from "./CommodityAllocationListFunc.vue?vue&type=style&index=0&id=2dd5351f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5351f",
  null
  
)

export default component.exports